import { render, staticRenderFns } from "./EmailResponse.vue?vue&type=template&id=07a8e984&scoped=true&"
import script from "./EmailResponse.vue?vue&type=script&lang=js&"
export * from "./EmailResponse.vue?vue&type=script&lang=js&"
import style0 from "./EmailResponse.vue?vue&type=style&index=0&id=07a8e984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a8e984",
  null
  
)

export default component.exports